export const FIND_CHAT_CONVERSATION_PARTNERS_REQUEST = 'FIND_CHAT_CONVERSATION_PARTNERS_REQUEST';

export const findChatConversationPartnersRequest = () => ({
    type: FIND_CHAT_CONVERSATION_PARTNERS_REQUEST,
});
